import ReactDOM from "react-dom/client";
import "./index.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./router/router.jsx";
import { Provider } from "react-redux";
import { store, persistor } from "./app/store.js"; // Import persistor
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "core-js/stable";
import "regenerator-runtime/runtime";

 

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
     
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
       <RouterProvider router={router} />
    </PersistGate>
  </Provider>
);

// //import React from "react";
// import ReactDOM from "react-dom/client";
// //import App from "./App.jsx";
// import "./index.css";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import { RouterProvider } from "react-router-dom";
// import { router } from "./router/router.jsx";
// import { Provider } from "react-redux";
// import { store } from "./app/store.js";
// import "react-toastify/dist/ReactToastify.css";
// import { ToastContainer } from "react-toastify";
// // import Notification from "./components/customTable/Notification.jsx";

// ReactDOM.createRoot(document.getElementById("root")).render(
//   // <React.StrictMode>
//   <Provider store={store}>
//     {/* <Notification /> */}
//     <RouterProvider router={router} />
//     <ToastContainer
//       position="top-right"
//       autoClose={1000}
//       hideProgressBar={false}
//       newestOnTop={false}
//       closeOnClick
//       rtl={false}
//       pauseOnFocusLoss
//       draggable
//       pauseOnHover
//       theme="colored"
//     />
//   </Provider>
//   // </React.StrictMode>
// );
